import flush from 'just-flush';
import { TaxonomyType } from '@stereoagency/constants';
import { taxonomy } from '@stereoagency/sanity-schema';
import { $globalSanityClient } from '@/sanity';

const totalCountsQuery = taxonomy.schema.builder
  .filter(`type in $taxonomy_types && !(_id in path("drafts.**"))`)
  .pick(['_id', 'type', 'slug'])
  .subquery({
    count: [
      `count(*[_type in $include_types && ^._id in taxonomies[]._ref])`,
      0
    ]
  })
  .use();

export default async function fetchTaxonomyCounts(
  taxonomyTypes: TaxonomyType[],
  includeTypes: string[]
) {
  const result = await $globalSanityClient.fetch<(typeof totalCountsQuery)[1]>(
    totalCountsQuery[0],
    {
      taxonomy_types: taxonomyTypes,
      include_types: includeTypes
    }
  );
  return new Map(
    flush(
      result.map<null | [string, number]>((count) => {
        if (!count.slug?.current) return null;
        return [count.slug.current, count.count ?? 0];
      })
    )
  );
}
